import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import type { MarkMessagesAsReadQuery } from './mark-messages-as-read.query';

/**
 * Mark messages as read use case.
 * Marks all unread messages for a case as read by the current user.
 */
@Injectable({ providedIn: 'root' })
export class MarkMessagesAsReadUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(query: MarkMessagesAsReadQuery): Observable<void> {
    this._state.setMarkingMessagesAsRead(true);
    this._state.setErrorMessages(null);

    return this._repository.markMessagesAsRead(query.caseId).pipe(
      finalize(() => {
        this._state.setMarkingMessagesAsRead(false);
      }),
      catchError((error) => {
        this._state.setErrorMessages(error.message || 'Failed to mark messages as read');
        return throwError(() => error);
      })
    );
  }
}
